<template>
    <layout>
        <main role="main" class="background-employer-dashboard">
        <div class="container">
            <h1 class="mt-5 pt-5 font-poppins font-weight-extra-light color-blue">{{ Lang.get('employerdashboard::pages/support/index.title') }}</h1>
            <h6 class="font-poppins font-weight-light font-size-18 color-blue">{{ Lang.get('employerdashboard::pages/support/index.subtitle') }}</h6>
            <div class="row mt-5">
                <div class="col-12">
                    <div class="card border-radius-8 shadow">
                        <div class="card-body p-0">
                            <div class="row">
<!--                                @todo where is the content-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    metaInfo() {
        return {
            title: Lang.get('employerdashboard::pages/support/index.title'),
        }
    },
    components: {
        Layout,
    },
    props: {
        user: Object,
    },
}
</script>
